import { render } from "./AddDocumentTypeCnfPopUp.vue?vue&type=template&id=10a9c0dc&scoped=true"
import script from "./AddDocumentTypeCnfPopUp.vue?vue&type=script&lang=js"
export * from "./AddDocumentTypeCnfPopUp.vue?vue&type=script&lang=js"

import "./AddDocumentTypeCnfPopUp.vue?vue&type=style&index=0&id=10a9c0dc&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a9c0dc"]])

export default __exports__